import Chat from '../chat/Chat'
import Feed from '../feed/Feed'
// (News, Summary imports unused here)
import layout from './Home.module.css'

const DashHome = () => {
  return (
    <div className={layout.mainDashboardhome}>
      <div className={layout.mainhome}>
        <Feed />
      </div>
      <div className={layout.righthome}>
        <Chat />
      </div>
    </div>
  )
}

export default DashHome
